<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-add' class='navbarbtn' v-if='showAddPower'
        @click='showTableEditorDialogMD(false)'>
        新 增
      </el-button>

      <el-button type='success' icon='sys sys-sql' class='navbarbtn'
        v-if='showExportMoveSqlPower' @click='exportSql()'>
        导出SQL
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :showOperationsColumn='true'
      :showDefaultExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='编辑' placement='top-start' v-if='showEditPower'>
          <el-button type='primary' circle style='padding: 4px;' @click='showTableEditorDialogMD(true, scope)'><i class='sys sys-edit'></i></el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletePower'>
          <el-button type='danger' circle style='padding: 4px;' @click='deleteOneTableEditor(scope)'><i class='sys sys-delete'></i></el-button>
        </el-tooltip>
      </template>
    </Table>

    <!-- 新增编辑弹出框 -->
    <el-dialog v-dialogDrag :title='editFlag ? "修改表格编辑器" : "添加表格编辑器"' :visible.sync='showTableEditorDialog'
      width='1160px' top='10px' lock-scroll>
      <el-form :model='tableEditorInfo' label-width='80px' style='margin-top: -20px;'
        label-position='right' size='mini'>
        <div class='hbox'>
          <el-form-item label='编号 ' prop='TableEditorCode' class='formRow mustIn'>
            <el-input v-model='tableEditorInfo.TableEditorCode' placeholder='必填' style='width: 200px;'
              :disabled='editFlag'></el-input>
          </el-form-item>
          <el-form-item label='名称 ' prop='TableEditorName' class='formRow mustIn'>
            <el-input v-model='tableEditorInfo.TableEditorName' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
          <el-form-item label='实体对象 ' prop='TableCode' class='formRow mustIn'>
            <el-input v-model='tableEditorInfo.TableCode' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
          <el-form-item label='时间校验 ' prop='TableCode' class='formRow'>
            <el-select v-model='tableEditorInfo.CheckOutTimeFlag' placeholder='请选择'
              style='width: 200px;' size='mini'>
              <el-option v-for='checkOutTimeFlag in mainTable.checkOutTimeFlags' :key='checkOutTimeFlag.code' :label='checkOutTimeFlag.name' :value='checkOutTimeFlag.code'>
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='主键1 ' prop='KeyCode1' class='formRow mustIn'>
            <el-input v-model='tableEditorInfo.KeyCode1' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
          <el-form-item label='主键2 ' prop='KeyCode2' class='formRow'>
            <el-input v-model='tableEditorInfo.KeyCode2' placeholder='可填' style='width: 200px;'></el-input>
          </el-form-item>
          <el-form-item label='主键3 ' prop='KeyCode3' class='formRow'>
            <el-input v-model='tableEditorInfo.KeyCode3' placeholder='可填' style='width: 200px;'></el-input>
          </el-form-item>
          <el-form-item label='主键4 ' prop='KeyCode4' class='formRow'>
            <el-input v-model='tableEditorInfo.KeyCode4' placeholder='可填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='保存宽度 ' prop='SaveWidth' class='formRow'>
            <el-input-number v-model='tableEditorInfo.SaveWidth' placeholder='请输入' style='width: 200px;' :min='0'></el-input-number>
          </el-form-item>
          <el-form-item label='保存高度 ' prop='SaveHeight' class='formRow'>
            <el-input-number v-model='tableEditorInfo.SaveHeight' placeholder='请输入' style='width: 200px;' :min='0'></el-input-number>
          </el-form-item>
          <el-form-item label='编辑宽度 ' prop='EditWidth' class='formRow'>
            <el-input-number v-model='tableEditorInfo.EditWidth' placeholder='请输入' style='width: 200px;' :min='0'></el-input-number>
          </el-form-item>
          <el-form-item label='编辑高度 ' prop='EditHeight' class='formRow'>
            <el-input-number v-model='tableEditorInfo.EditHeight' placeholder='请输入' style='width: 200px;' :min='0'></el-input-number>
          </el-form-item>
        </div>

        <div class='hbox' v-if='editFlag'>
          <el-table :data='tableEditorInfo.FieldInfo' border height='300px' style='margin-left: 20px; margin-top: 10px;'
            :cell-style='tableCellStyle' :header-cell-style='tableHeaderCellStyle' size='medium'
            @row-click='fieldRowClick' :row-style='fieldRowStyle'>
            <el-table-column type='index' label='序号' header-align='center' align='center' width='60' fixed></el-table-column>
            <el-table-column prop='FieldCode' label='字段编号' width='160' fixed>
              <template #header>
                <span style='color: blue;'>字段编号</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.FieldCode' placeholder='必填'
                  class='tableInput' style='width: 140px;'/>
                <span v-else>{{scope.row.FieldCode}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='FieldName' label='字段名称' width='160' fixed>
              <template #header>
                <span style='color: blue;'>字段名称</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.FieldName' placeholder='必填'
                  class='tableInput' style='width: 140px;' @change='fieldNameChange(scope.row)'/>
                <span v-else>{{scope.row.FieldName}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='FieldLabel' label='标签名称' width='160'>
              <template #header>
                <span style='color: blue;'>标签名称</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.FieldLabel' placeholder='必填'
                  class='tableInput' style='width: 140px;'/>
                <span v-else>{{scope.row.FieldLabel}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='DataType' label='数据类型' width='120'>
              <template #header>
                <span style='color: blue;'>数据类型</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.DataType' placeholder='必选'
                  class='tableInput' style='width: 100px;'>
                  <option v-for='dataType in dataTypes' :key='dataType.code' :value='dataType.code'>{{dataType.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.DataType, 'DataType')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='FieldType' label='输入框类型' width='120'>
              <template #header>
                <span style='color: blue;'>输入框类型</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.FieldType' placeholder='必选'
                  class='tableInput' style='width: 100px;'>
                  <option v-for='fieldType in fieldTypes' :key='fieldType.code' :value='fieldType.code'>{{fieldType.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.FieldType, 'FieldType')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='NotNull' label='是否必填项' width='100'>
              <template #header>
                <span style='color: blue;'>是否必填项</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.NotNull' placeholder='必选'
                  class='tableInput' style='width: 80px;'>
                  <option v-for='notNull in notNulls' :key='notNull.code' :value='notNull.code'>{{notNull.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.NotNull, 'NotNull')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='SaveDisplay' label='新增显示' width='100'>
              <template #header>
                <span style='color: blue;'>新增显示</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.SaveDisplay' placeholder='必选'
                  class='tableInput' style='width: 80px;' @change='saveDisplayChange(scope.row)'>
                  <option v-for='display in displays' :key='display.code' :value='display.code'>{{display.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.SaveDisplay, 'SaveDisplay')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='SaveDisabled' label='新增不可编辑' width='120'>
              <template #header>
                <span style='color: blue;'>新增不可编辑</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.SaveDisabled' placeholder='必选'
                  class='tableInput' style='width: 100px;'>
                  <option v-for='disabled in disableds' :key='disabled.code' :value='disabled.code'>{{disabled.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.SaveDisabled, 'SaveDisabled')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='EditSave' label='修改保存' width='100'>
              <template #header>
                <span style='color: blue;'>修改保存</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.EditSave' placeholder='必选'
                  class='tableInput' style='width: 80px;'>
                  <option v-for='editSave in editSaves' :key='editSave.code' :value='editSave.code'>{{editSave.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.EditSave, 'EditSave')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='EditDisplay' label='修改显示' width='100'>
              <template #header>
                <span style='color: blue;'>修改显示</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.EditDisplay' placeholder='必选'
                  class='tableInput' style='width: 80px;' @change='editDisplayChange(scope.row)'>
                  <option v-for='display in displays' :key='display.code' :value='display.code'>{{display.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.EditDisplay, 'EditDisplay')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='EditDisabled' label='修改不可编辑' width='120'>
              <template #header>
                <span style='color: blue;'>修改不可编辑</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.EditDisabled' placeholder='必选'
                  class='tableInput' style='width: 100px;'>
                  <option v-for='disabled in disableds' :key='disabled.code' :value='disabled.code'>{{disabled.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.EditDisabled, 'EditDisabled')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='LabelWidth' label='标签宽度' width='100'>
              <template #header>
                <span style='color: blue;'>标签宽度</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.LabelWidth' placeholder='必填'
                  class='tableInput' style='width: 80px;' @change='numberChange(scope.row, "LabelWidth")'/>
                <span v-else>{{scope.row.LabelWidth}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='LabelPosition' label='标签位置' width='100'>
              <template #header>
                <span style='color: blue;'>标签位置</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.LabelPosition' placeholder='必选'
                  class='tableInput' style='width: 80px;'>
                  <option v-for='labelPosition in labelPositions' :key='labelPosition.code' :value='labelPosition.code'>{{labelPosition.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.LabelPosition, 'LabelPosition')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='InputWidth' label='输入框宽度' width='100'>
              <template #header>
                <span style='color: blue;'>输入框宽度</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.InputWidth' placeholder='必填'
                  class='tableInput' style='width: 80px;' @change='numberChange(scope.row, "InputWidth")'/>
                <span v-else>{{scope.row.InputWidth}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='MarginRight' label='右边距' width='100'>
              <template #header>
                <span style='color: blue;'>右边距</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.MarginRight' placeholder='必填'
                  class='tableInput' style='width: 80px;' @change='numberChange(scope.row, "MarginRight")'/>
                <span v-else>{{scope.row.MarginRight}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='SaveReadOnly' label='新增只读' width='100'>
              <template #header>
                <span style='color: blue;'>新增只读</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.SaveReadOnly' placeholder='必选'
                  class='tableInput' style='width: 80px;'>
                  <option v-for='readOnly in readOnlys' :key='readOnly.code' :value='readOnly.code'>{{readOnly.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.SaveReadOnly, 'SaveReadOnly')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='EditReadOnly' label='修改只读' width='100'>
              <template #header>
                <span style='color: blue;'>修改只读</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.EditReadOnly' placeholder='必选'
                  class='tableInput' style='width: 80px;'>
                  <option v-for='readOnly in readOnlys' :key='readOnly.code' :value='readOnly.code'>{{readOnly.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.EditReadOnly, 'EditReadOnly')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='CustomField' label='自定义输入框' width='120'>
              <template #header>
                <span style='color: blue;'>自定义输入框</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.CustomField' placeholder='必选'
                  class='tableInput' style='width: 100px;'>
                  <option v-for='customField in customFields' :key='customField.code' :value='customField.code'>{{customField.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.CustomField, 'CustomField')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='SaveDefaultValType' label='新增默认值类型' width='130'>
              <template #header>
                <span style='color: blue;'>新增默认值类型</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.SaveDefaultValType' placeholder='必选'
                  class='tableInput' style='width: 110px;'>
                  <option v-for='defaultValType in defaultValTypes' :key='defaultValType.code' :value='defaultValType.code'>{{defaultValType.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.SaveDefaultValType, 'SaveDefaultValType')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='FieldCode' label='新增默认值' width='100'>
              <template #header>
                <span style='color: blue;'>新增默认值</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.SaveDefaultVal' placeholder='可填'
                  class='tableInput' style='width: 80px;'/>
                <span v-else>{{scope.row.SaveDefaultVal}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='FieldCode' label='修改默认值类型' width='130'>
              <template #header>
                <span style='color: blue;'>修改默认值类型</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.EditDefaultValType' placeholder='必选'
                  class='tableInput' style='width: 110px;'>
                  <option v-for='defaultValType in defaultValTypes' :key='defaultValType.code' :value='defaultValType.code'>{{defaultValType.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.EditDefaultValType, 'EditDefaultValType')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='FieldCode' label='修改默认值' width='100'>
              <template #header>
                <span style='color: blue;'>修改默认值</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.EditDefaultVal' placeholder='可填'
                  class='tableInput' style='width: 80px;'/>
                <span v-else>{{scope.row.EditDefaultVal}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='Placeholder' label='提示文本' width='100'>
              <template #header>
                <span style='color: blue;'>提示文本</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.Placeholder' placeholder='请输入'
                  class='tableInput' style='width: 80px;'/>
                <span v-else>{{scope.row.Placeholder}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='MaxNumber' label='最大数字' width='100'>
              <template #header>
                <span style='color: blue;'>最大数字</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.MaxNumber' placeholder='可填'
                  class='tableInput' style='width: 80px;' @change='numberChange(scope.row, "MaxNumber")'/>
                <span v-else>{{scope.row.MaxNumber}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='MinNumber' label='最小数字' width='100'>
              <template #header>
                <span style='color: blue;'>最小数字</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.MinNumber' placeholder='可填'
                  class='tableInput' style='width: 80px;' @change='numberChange(scope.row, "MinNumber")'/>
                <span v-else>{{scope.row.MinNumber}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='DateFormat' label='日期格式' width='150'>
              <template #header>
                <span style='color: blue;'>日期格式</span>
              </template>
              <template #default='scope'>
                <select v-if='scope.row.GUID === editGUID' v-model='scope.row.DateFormat' placeholder='可选'
                  class='tableInput' style='width: 130px;'>
                  <option v-for='dateFormat in dateFormats' :key='dateFormat.code' :value='dateFormat.code'>{{dateFormat.name}}</option>
                </select>
                <span v-else>{{fieldSpecialStringDisplayTransform(scope.row.DateFormat, 'DateFormat')}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='DecimalDigits' label='小数位数' width='100'>
              <template #header>
                <span style='color: blue;'>小数位数</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.DecimalDigits' placeholder='可填'
                  class='tableInput' style='width: 80px;' @change='numberChange(scope.row, "DecimalDigits")'/>
                <span v-else>{{scope.row.DecimalDigits}}</span>
              </template>
            </el-table-column>

            <el-table-column prop='NumberStep' label='数字步距' width='100'>
              <template #header>
                <span style='color: blue;'>数字步距</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='scope.row.NumberStep' placeholder='可填'
                  class='tableInput' style='width: 80px;' @change='numberChange(scope.row, "NumberStep")'/>
                <span v-else>{{scope.row.NumberStep}}</span>
              </template>
            </el-table-column>

            <el-table-column label='移至' width='50' fixed='right'>
              <template #header>
                <span style='color: blue;'>移至</span>
              </template>
              <template #default='scope'>
                <input v-if='scope.row.GUID === editGUID' v-model='moveToRow'
                  class='tableInput' style='width: 30px;' @keyup.enter='moveToRowFnc(scope.$index)'/>
              </template>
            </el-table-column>

            <el-table-column label='操作' width='120' fixed='right'>
              <template #default='scope'>
                <el-tooltip effect='dark' content='删除' placement='top-start'>
                  <el-button type='danger' circle style='padding: 4px;' size='mini' @click='deleteOneFieldRow(scope)'><i class='sys sys-delete tableIconSize'></i></el-button>
                </el-tooltip>
                <el-tooltip effect='dark' content='上移' placement='top-start'>
                  <el-button type='primary' circle style='padding: 4px;' @click='upOneField(scope.$index)'><i class='sys sys-box-up'></i></el-button>
                </el-tooltip>
                <el-tooltip effect='dark' content='下移' placement='top-start'>
                  <el-button type='primary' circle style='padding: 4px;' @click='downOneField(scope.$index)'><i class='sys sys-box-down'></i></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      <div class='dialogButtomBtn'>
        <el-button type='primary' @click='addOneFieldRow()' size='mini' v-if='editFlag'>添加行</el-button>
        <el-button type='primary' @click='saveOrEditTableEditor()' size='mini'>保存</el-button>
        <el-button @click='tableEditorReset(tableEditorInfo.TableEditorCode)' size='mini'>重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import tableEditor from '@/components/sys/TableEditor'
import power from '@/components/sys/Power'
import code from '@/components/sys/Code'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'

export default {
  name: 'TableEditor',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'SYS_TableEditor',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],

        checkOutTimeFlags: []
      },

      editFlag: false,
      showTableEditorDialog: false,
      tableEditorInfo: {
        TableEditorCode: '',
        TableEditorName: '',
        SaveWidth: '',
        SaveHeight: '',
        EditWidth: '',
        EditHeight: '',
        TableCode: '',
        KeyCode1: '',
        KeyCode2: '',
        KeyCode3: '',
        KeyCode4: '',
        KeyCode5: '',
        TimeStamp: '',
        CheckOutTimeFlag: '1',
        FieldInfo: []
      },
      editGUID: '',
      moveToRow: '',

      labelPositions: [],
      displays: [],
      disableds: [],
      readOnlys: [],
      dataTypes: [],
      fieldTypes: [],
      dateFormats: [],
      customFields: [],
      notNulls: [],
      defaultValTypes: [],
      editSaves: [],

      showAddPower: false,
      showEditPower: false,
      showDeletePower: false,
      showExportMoveSqlPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.mainTable.checkOutTimeFlags = code.getCode(codes, 'SYS_TableEditor_CheckOutTimeFlag')
    that.labelPositions = code.getCode(codes, 'SYS_TableEditorField_LabelPosition')
    that.displays = code.getCode(codes, 'SYS_TableEditorField_Display')
    that.disableds = code.getCode(codes, 'SYS_TableEditorField_Disabled')
    that.readOnlys = code.getCode(codes, 'SYS_TableEditorField_ReadOnly')
    that.dataTypes = code.getCode(codes, 'SYS_TableEditorField_DataType')
    that.fieldTypes = code.getCode(codes, 'SYS_TableEditorField_FieldType')
    that.dateFormats = code.getCode(codes, 'SYS_TableEditorField_DateFormat')
    that.customFields = code.getCode(codes, 'SYS_TableEditorField_CustomField')
    that.notNulls = code.getCode(codes, 'SYS_TableEditorField_NotNull')
    that.defaultValTypes = code.getCode(codes, 'SYS_TableEditorField_DefaultValType')
    that.editSaves = code.getCode(codes, 'SYS_TableEditorField_EditSave')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      const that = this
      if (columnCode === 'CheckOutTimeFlag') {
        return that.mainTable.checkOutTimeFlags
      }
    },

    // 保存修改表格编辑器弹出框显示方法
    showTableEditorDialogMD: async function (editFlag, scope) {
      const that = this
      that.editFlag = editFlag
      that.editFieldCode = ''
      await that.tableEditorReset(editFlag ? scope.data.row.TableEditorCode : '')
      that.showTableEditorDialog = true
    },

    // 表格编辑器弹出框数据重置方法
    tableEditorReset: async function (tableEditorCode) {
      const that = this
      if (that.editFlag) {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await tableEditor.getTableEditorAndFieldInfo(tableEditorCode)
        if (rtnObj.error === '000000') {
          that.tableEditorInfo = rtnObj.tableEditorInfo
          that.tableEditorInfo.FieldInfo = rtnObj.tableEditorFieldInfo
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      } else {
        that.tableEditorInfo.TableEditorCode = ''
        that.tableEditorInfo.TableEditorName = ''
        that.tableEditorInfo.SaveWidth = ''
        that.tableEditorInfo.SaveHeight = ''
        that.tableEditorInfo.EditWidth = ''
        that.tableEditorInfo.EditHeight = ''
        that.tableEditorInfo.TableCode = ''
        that.tableEditorInfo.KeyCode1 = ''
        that.tableEditorInfo.KeyCode2 = ''
        that.tableEditorInfo.KeyCode3 = ''
        that.tableEditorInfo.KeyCode4 = ''
        that.tableEditorInfo.KeyCode5 = ''
        that.tableEditorInfo.CheckOutTimeFlag = '1'
        that.tableEditorInfo.TimeStamp = ''
        that.tableEditorInfo.FieldInfo = []
      }
    },

    // 保存表格编辑器弹出框数据
    saveOrEditTableEditor: async function () {
      const that = this
      if (that.tableEditorInfo.TableEditorCode === '') {
        that.$message.error('请输入表格编辑器编号！')
        return
      }
      if (that.tableEditorInfo.TableEditorName === '') {
        that.$message.error('请输入表格编辑器名称！')
        return
      }
      if (that.tableEditorInfo.TableCode === '') {
        that.$message.error('请输入实体对象！')
        return
      }
      if (that.tableEditorInfo.KeyCode1 === '') {
        that.$message.error('请输入实体主键1！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      let rtnObj
      if (that.editFlag) {
        rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.UpdateTableEditor', {
          tableEditorInfo: that.tableEditorInfo
        })
      } else {
        rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.AddTableEditor', {
          tableEditorInfo: that.tableEditorInfo
        })
      }
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success(that.editFlag ? '恭喜你，变更表格编辑器信息成功！' : '恭喜你，新增表格编辑器成功！')
        that.showTableEditorDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除表格编辑器
    deleteOneTableEditor: function (scope) {
      const that = this
      that.$confirm('此操作将永久删除该表格编辑器, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.DeleteTableEditor', {
          tableEditorCode: scope.data.row.TableEditorCode
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('恭喜你，删除表格编辑器信息成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 表格编辑器弹出框表格特征字符串转义显示方法
    fieldSpecialStringDisplayTransform: function (val, FieldCode) {
      const that = this
      if (FieldCode === 'LabelPosition') {
        return table.specialStringDisplayTransform(val, that.labelPositions)
      } else if (FieldCode === 'SaveDisplay') {
        return table.specialStringDisplayTransform(val, that.displays)
      } else if (FieldCode === 'SaveDisabled') {
        return table.specialStringDisplayTransform(val, that.disableds)
      } else if (FieldCode === 'SaveReadOnly') {
        return table.specialStringDisplayTransform(val, that.readOnlys)
      } else if (FieldCode === 'EditDisplay') {
        return table.specialStringDisplayTransform(val, that.displays)
      } else if (FieldCode === 'EditDisabled') {
        return table.specialStringDisplayTransform(val, that.disableds)
      } else if (FieldCode === 'EditReadOnly') {
        return table.specialStringDisplayTransform(val, that.readOnlys)
      } else if (FieldCode === 'DataType') {
        return table.specialStringDisplayTransform(val, that.dataTypes)
      } else if (FieldCode === 'FieldType') {
        return table.specialStringDisplayTransform(val, that.fieldTypes)
      } else if (FieldCode === 'CustomField') {
        return table.specialStringDisplayTransform(val, that.customFields)
      } else if (FieldCode === 'NotNull') {
        return table.specialStringDisplayTransform(val, that.notNulls)
      } else if (FieldCode === 'SaveDefaultValType') {
        return table.specialStringDisplayTransform(val, that.defaultValTypes)
      } else if (FieldCode === 'EditDefaultValType') {
        return table.specialStringDisplayTransform(val, that.defaultValTypes)
      } else if (FieldCode === 'EditSave') {
        return table.specialStringDisplayTransform(val, that.editSaves)
      } else if (FieldCode === 'DateFormat') {
        return table.specialStringDisplayTransform(val, that.dateFormats)
      } else {
        return val
      }
    },

    // 表格编辑器弹出框表格行单机方法
    fieldRowClick: function (row, event, column) {
      const that = this
      that.editGUID = row.GUID
    },

    // 数字输入框值改变方法
    numberChange: function (row, code) {
      try {
        row[code] = parseFloat(row[code])
        if (isNaN(row[code])) {
          row[code] = 0
        }
      } catch (err) {
        row[code] = 0
      }
    },

    // 保存显示改变方法
    saveDisplayChange: function (row) {
      if (row.SaveDisplay === '1') {
        row.SaveDisabled = '0'
        row.SaveReadOnly = '0'
      } else {
        row.SaveDisabled = '1'
        row.SaveReadOnly = '1'
      }
    },

    // 修改显示改变方法
    editDisplayChange: function (row) {
      if (row.EditDisplay === '1') {
        row.EditDisabled = '0'
        row.EditReadOnly = '0'
      } else {
        row.EditDisabled = '1'
        row.EditReadOnly = '1'
      }
    },

    // 字段名称改变方法
    fieldNameChange: function (row) {
      row.FieldLabel = row.FieldName
    },

    // 字段行删除方法
    deleteOneFieldRow: function (scope) {
      this.tableEditorInfo.FieldInfo.splice(scope.$index, 1)
    },

    // 字段添加方法
    addOneFieldRow: function () {
      const oneFilterInfo = {
        GUID: Math.random().toString(),
        TableEditorCode: this.tableEditorInfo.TableEditorCode,
        FieldCode: '',
        FieldName: '',
        FieldLabel: '',
        Seq: this.tableEditorInfo.FieldInfo.length + 1,
        LabelWidth: 80,
        LabelPosition: '2',
        InputWidth: 200,
        MarginRight: 10,
        SaveDisplay: '1',
        SaveDisabled: '0',
        SaveReadOnly: '0',
        EditDisplay: '1',
        EditDisabled: '0',
        EditReadOnly: '0',
        DataType: '0',
        FieldType: '0',
        Placeholder: '请输入',
        MaxNumber: null,
        MinNumber: null,
        MaxDate: '',
        MinDate: '',
        DateFormat: '',
        DecimalDigits: null,
        NumberStep: null,
        CustomField: '0',
        NotNull: '0',
        SaveDefaultVal: '',
        SaveDefaultValType: '0',
        EditDefaultVal: '',
        EditDefaultValType: '0',
        EditSave: '1'
      }
      this.tableEditorInfo.FieldInfo.push(oneFilterInfo)
    },

    // 上移
    upOneField: function (index) {
      if (index === 0) return
      const that = this
      that.tableEditorInfo.FieldInfo[index - 1] = [that.tableEditorInfo.FieldInfo[index], that.tableEditorInfo.FieldInfo[index] = that.tableEditorInfo.FieldInfo[index - 1]][0]
      that.tableEditorInfo.FieldInfo.splice(0, 0)
    },

    // 下移
    downOneField: function (index) {
      const that = this
      if (index === that.tableEditorInfo.FieldInfo.length - 1) return
      that.tableEditorInfo.FieldInfo[index] = [that.tableEditorInfo.FieldInfo[index + 1], that.tableEditorInfo.FieldInfo[index + 1] = that.tableEditorInfo.FieldInfo[index]][0]
      that.tableEditorInfo.FieldInfo.splice(0, 0)
    },

    // 移至
    moveToRowFnc: function (index) {
      const that = this
      try {
        that.moveToRow = parseFloat(that.moveToRow)
        if (isNaN(that.moveToRow)) {
          that.moveToRow = ''
        }
      } catch (err) {
        that.moveToRow = ''
      }
      if (that.moveToRow !== '') {
        if (that.moveToRow <= 0) {
          that.moveToRow = 1
        }
        if (that.moveToRow > that.tableEditorInfo.FieldInfo.length) {
          that.moveToRow = that.tableEditorInfo.FieldInfo.length
        }
        if (index === that.moveToRow - 1) {
          return
        } else if (index > that.moveToRow - 1) {
          for (let i = index; i > that.moveToRow - 1; i--) {
            that.tableEditorInfo.FieldInfo[i] = [that.tableEditorInfo.FieldInfo[i - 1], that.tableEditorInfo.FieldInfo[i - 1] = that.tableEditorInfo.FieldInfo[i]][0]
          }
        } else if (index < that.moveToRow - 1) {
          for (let i = index; i < that.moveToRow - 1; i++) {
            that.tableEditorInfo.FieldInfo[i] = [that.tableEditorInfo.FieldInfo[i + 1], that.tableEditorInfo.FieldInfo[i + 1] = that.tableEditorInfo.FieldInfo[i]][0]
          }
        }
        that.tableEditorInfo.FieldInfo.splice(0, 0)
        that.moveToRow = ''
      }
    },

    // 字段表格行样式
    fieldRowStyle: function (row, rowIndex) {
      if (row.row.SaveDisplay === '0' && row.row.EditDisplay === '0') {
        return { 'background-color': '#CCCCCC' }
      }
    },

    // 导出Sql
    exportSql: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.ExportSql', {
        selections: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        let consoleStr = ''
        for (let i = 0; i < rtnObj.sqlList.length; i++) {
          consoleStr += rtnObj.sqlList[i]
        }
        console.log(consoleStr)
        that.$message.success('恭喜你，导出成功，请到控制台查看！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格单元格样式
    tableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    tableHeaderCellStyle: function () {
      return { padding: '0px', 'background-color': '#f5f7fa' }
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.hbox{
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: left;
}
.formRow{
  margin-top: 2px;
  margin-bottom: 3px;
}
.dialogButtomBtn{
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.tableInput {
  height: 20px;
  line-height: 20px;
  border: 0;
  background-color: transparent;
  padding: 0;
}
</style>
